import { get, post, put, destroy } from './config';

const Notification = {
  getNotificationsList: (params) =>
    get('v1/notifications/users/list', { params }),
  getNotificationById: (notificationsId) =>
    post(`v1/notifications/client/seen/${notificationsId}`),
  getQuantityNotifications : (params) =>
    get('v1/notifications/client/quantity', {params}),
  markNotificationsAsSeen: (notificationIds) =>
    post('v1/notifications/client/seen', notificationIds),
  getOrderNotificationById: (orderId) =>
    get(`v1/ordernotification/${orderId}`),
  markOrderNotificationAsRead: (id) =>
    post(`v1/ordernotification/read/${id}`),
  getUserNotificationsCount: () =>
    get('v1/notifications/users/count?isRead=false'),
  markUserNotificationAsRead: (id) =>
    put(`v1/notifications/users/read/${id}`),
}
export default Notification;